export function getNodeOffset(node: HTMLDivElement) {
  const parent = node.parentNode as HTMLDivElement | undefined;

  if (!parent) {
    return 0;
  }

  const { left } = node.getBoundingClientRect();
  const { left: parentLeft } = parent.getBoundingClientRect();

  return left - parentLeft;
}
